import Types from './types';

export const UpdateAvailable = () => ({
  type: Types.NOTIFICATIONS_UPDATE_AVAILABLE
});

export const UpdateDismissed = () => ({
  type: Types.NOTIFICATIONS_UPDATE_DISMISSED
});

export const UpdateApplied = () => ({
  type: Types.NOTIFICATIONS_UPDATE_APPLIED
}); 